import { useState } from "react"
import { StandardButton } from "../atoms/buttons"
import { IconAtom } from "../atoms/iconAtom"
import { StandardComp } from "../atoms/standardComp"

export const TrueFalseChoice = ({ answers, clickAnswer }) => {
  const [answer,setAnswer ] = useState({left:0, right:0})
    const handleAnswerLeft = () => {
        setAnswer({...answer, left:1, right:0})
        clickAnswer(0)
    }
    const handleAnswerRight = () => {
        setAnswer({...answer, left:0, right:1})
        clickAnswer(1)
    }
    return (
        <div className="vertical answers-div true-false-phone" style={{ width: 'unset' }}>


            <div className="horizontal">
            <StandardComp
                    editClass={answer?.left && "active-standard"}
                    onClick={() => handleAnswerLeft()}

                    style={{ margin: "1rem", padding: "0.5rem", width:"50%" }}
                    content={
                        <div className="horizontal multiplechoice-button">
                            <div className="check-circle">
                                {answer?.left ? <IconAtom
                                    icon2={"check"}
                                />:""}
                            </div>
                            <p className="standard-text-color">Waar</p>
                        </div>
                    }
            />
            <StandardComp
                    editClass={answer?.right && "active-standard"}
                    onClick={() => handleAnswerRight(0)}

                    style={{ margin: "1rem", padding: "0.5rem", width:"50%" }}
                    content={
                        <div className="horizontal multiplechoice-button">
                            <div className="check-circle">
                                {answer?.right ? <IconAtom
                                    icon2={"check"}
                                />:""}
                            </div>
                            <p className="standard-text-color">Niet waar</p>
                        </div>
                    }
            />
                
                
            </div>


        </div>
    )
}